import { useTranslation } from 'libs/i18n';
import { LinkLabel, Typography } from 'libs/ui';

const LINKS = {
  W8BENForm: 'https://www.irs.gov/pub/irs-pdf/fw8ben.pdf',
  W8BENEForm: 'https://www.irs.gov/pub/irs-pdf/fw8bene.pdf',
};

interface Props {
  formType: 'W8BENForm' | 'W8BENEForm';
}
export const SubTitle = ({ formType }: Props) => {
  const { t } = useTranslation();

  const subTitle = t(`onboarding.${formType}.subtitle`, {
    returnObjects: true,
  });

  return (
    <Typography variantMobile="caption">
      {subTitle.map((t) => {
        if (t.type === 'link') {
          return (
            <LinkLabel
              href={LINKS[formType]}
              label={t.value}
              mode="text"
              target="_blank"
              typographyVariantMobile="caption"
            />
          );
        }
        return t.value;
      })}
    </Typography>
  );
};
